<template>
  <div class="text-center" data-cy="base-dialog-button">
    <v-dialog v-model="showDialog" :width="width" :persistent="persistent">
      <template v-slot:activator="{ on }">
        <v-btn
          class="mx-3"
          :icon="icon"
          :color="color"
          v-bind="$attrs"
          v-on="on"
          data-cy="open-dialog-btn"
        >
          <v-icon v-if="buttonIcon !== undefined" :left="!icon">
            {{ buttonIcon }}
          </v-icon>
          <template v-if="!icon">
            {{ buttonText }}
          </template>
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline background">
          {{ dialogTitle }}</v-card-title
        >

        <v-divider></v-divider>
        <v-layout column justify-center align-center>
          <v-card-text>
            <div class="px-2">
              <v-form v-model="isValid" ref="form">
                <slot name="content"></slot>
              </v-form>
            </div>
          </v-card-text>
        </v-layout>
        <v-divider></v-divider>
        <v-card-actions class="py-3">
          <slot name="left-actions">
            <v-btn text @click="cancel" data-cy="btn-cancel"
              >{{ i18n.t("_Cancel") }}
            </v-btn>
            <v-spacer />
          </slot>
          <slot name="actions"> </slot>
          <v-btn
            :color="color"
            @click="confirm"
            :disabled="!isValid"
            data-cy="btn-confirm"
            >{{ confirmText !== undefined ? confirmText : i18n.t("_Confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import i18n from "../helper/i18n"
export default {
  props: {
    persistent: {
      type: Boolean,
      default: true,
    },
    dialogTitle: {
      type: String,
      required: true,
    },
    buttonIcon: {
      type: String,
    },
    buttonIconColor: {
      type: String,
    },
    color: {
      type: String,
      required: false,
      default: "primary",
    },
    buttonText: {
      type: String,
    },
    width: {
      type: String,
      default: " auto",
    },
    icon: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    confirmText: {
      type: String,
    },
  },
  data() {
    return {
      showDialog: false,
      isValid: false,
      i18n:i18n
    };
  },
  computed: {},
  methods: {
    cancel() {
      this.showDialog = false;
      this.$emit("cancel");
    },
    confirm() {
      if (!this.isValid) return;
      this.$emit("confirm", this.value);
      this.showDialog = false;
    },
  },
};
</script>
